import React, { useEffect } from "react";
import AllRoute from "../router";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import PageLayout from "../PageLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ArgusAuthProvider } from "../../contexts/ArgusAuthContext";
import { ArgusCartProvider } from "../../contexts/ArgusCartContext";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import ReactGA from "react-ga4";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ArgusAuthProvider>
          <ArgusCartProvider>
            <ThemeProvider theme={theme}>
              <PageLayout>
                <AllRoute />
                <ToastContainer />
              </PageLayout>
            </ThemeProvider>
          </ArgusCartProvider>
        </ArgusAuthProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
